/* Nav.js */
import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import logoImg from "@/assets/icons/icon-mobilicar-logo_bk.png";

import { ReactComponent as IconDashboard } from "@/assets/icons/menus/dashboard.svg";
import { ReactComponent as IconChecks } from "@/assets/icons/menus/checks.svg";
import { ReactComponent as IconSales } from "@/assets/icons/menus/sales.svg";
import { ReactComponent as IconDelivery } from "@/assets/icons/menus/delivery.svg";
import { ReactComponent as IconDraw } from "@/assets/icons/menus/draw.svg";
import { ReactComponent as IconMoneybag } from "@/assets/icons/menus/money-bag.svg";
import { ReactComponent as IconPlaces } from "@/assets/icons/menus/places.svg";
import { ReactComponent as IconChart } from "@/assets/icons/menus/chart.svg";
import { ReactComponent as IconSupport } from "@/assets/icons/menus/support.svg";
import { ReactComponent as IconVehicle } from "@/assets/icons/menus/vehicle.svg";
import { ReactComponent as IconTire } from "@/assets/icons/menus/tire.svg";
import { ReactComponent as IconSettings } from "@/assets/icons/menus/gear.svg";
import { ReactComponent as IconCredit } from "@/assets/icons/menus/credit_card.svg";
import { ReactComponent as IconContract } from "@/assets/icons/menus/contract.svg";
import { ReactComponent as IconManage } from "@/assets/icons/menus/manage.svg";
import { ReactComponent as IconSmartphone } from "@/assets/icons/menus/smartphone.svg";

const Nav = () => {
    const { pathname } = useLocation();
    const navigator = useNavigate();
    const [openMenu, setOpenMenu] = useState(null);
    const [navToggleStatus, setNavToggleStatus] = useState(false);

    const member = useSelector((state) => state.myInfo);
    const navKey = member ? `${member.id}-${member.roles.join(",")}` : "no-member";

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const menuItems = [
        {
            idx: 0,
            label: "대시보드",
            path: "/dashboard",
            icon: IconDashboard,
            sub: null,
        },
        {
            idx: 1,
            label: "차량 현황",
            icon: IconVehicle,
            defaultPath: "/vehicle/manage",
            sub: [
                { path: "/vehicle/manage", label: "차량 전체 현황" },
                { path: "/vehicle/manage/register", label: "차량 등록", display: false },
                { path: "/vehicle/manage/excel", label: "차량 엑셀 등록", display: false },
                { path: "/vehicle/manage/register/history", label: "차량 등록 히스토리", display: false },
                { path: "/vehicle/waiting", label: "대기 현황" },
                { path: "/vehicle/garage", label: "차고지 현황" },
            ],
        },
        {
            idx: 2,
            label: "보험 영업",
            icon: IconSales,
            defaultPath: "/order/manage",
            sub: [
                { path: "/order/manage", label: "실시간 오더" },
                { path: "/order/assignment", label: "배정/요청 목록" },
                { path: "/order/register", label: "신규 오더 요청", display: false },
                { path: "/order/detail", label: "오더 상세", display: false },
            ],
        },
        {
            idx: 3,
            label: "계약 관리",
            icon: IconSmartphone,
            defaultPath: "/contract/register",
            sub: [
                { path: "/contract/register", label: "계약서 작성" },
                { path: "/contract/status", label: "계약서 작성/발송 현황" },
                { path: "/contract/send/fail", label: "비대면 계약서 전송실패 목록" },
                { path: "/contract/online", label: "비대면 고객 서명 미완료" },
            ],
        },
        {
            idx: 4,
            label: "탁송",
            icon: IconDelivery,
            defaultPath: "/delivery/history",
            sub: [
                { path: "/delivery/request", label: "탁송 신청", display: false },
                { path: "/delivery/history", label: "탁송 이력 관리" },
            ],
        },
        {
            idx: 5,
            label: "마일리지",
            icon: IconCredit,
            defaultPath: "/mileage/history",
            sub: [{ path: "/mileage/history", label: "마일리지 적립/사용 내역" }],
        },
        {
            idx: 6,
            label: "청구/수납",
            icon: IconSupport,
            defaultPath: "/billing/status",
            sub: [{ path: "/billing/status", label: "청구 요청 현황" }],
        },
        {
            idx: 7,
            label: "일반 관리",
            icon: IconSettings,
            defaultPath: "/admin/mypage",
            sub: [
                { path: "/admin/mypage", label: "마이페이지" },
                { path: "/admin/notice", label: "공지사항" },
                { path: "/admin/notification", label: "알림" },
                { path: "/admin/policy-management", label: "약관 관리" },
                // { path: "/admin/insurance-management", label: "보험 관리" },
                { path: "/admin/operator-management", label: "영업자 관리" },
                { path: "/admin/partner-management", label: "소개처 관리" },
                { path: "/admin/workshop-management", label: "공업사 관리" },
            ],
        },
        {
            idx: 8,
            label: "사업자 관리",
            icon: IconManage,
            defaultPath: "/business/manage",
            sub: [{ path: "/business/manage", label: "사업자 관리/인감 등록" }],
        },
        {
            idx: 9,
            label: "ERP 관리",
            icon: IconSettings,
            defaultPath: "/erp/member/manage",
            sub: [
                { path: "/erp/member/manage", label: "회원 목록" },
                { path: "/erp/member/order", label: "오더 회원 목록" },
                { path: "/erp/vehicle/manage", label: "차량 목록" },
                { path: "/erp/order/manage", label: "오더 목록" },
                { path: "/erp/self-claim/manage", label: "셀프클레임 목록" },
                { path: "/erp/contract/status", label: "계약 목록" },
                { path: "/erp/delivery/history", label: "탁송 목록" },
                { path: "/erp/mileage/history", label: "마일리지 이용 목록" },
                { path: "/erp/billing/status", label: "청구 목록" },
                { path: "/erp/notice", label: "공지사항" },
                { path: "/erp/release", label: "릴리즈 노트" },
                { path: "/erp/event", label: "이벤트" },
            ],
            roles: ["MASTER", "ADMIN"],
        },
    ];

    // member.roles에 따라 접근 권한이 없는 메뉴 항목은 필터링 처리
    const filteredMenuItems = menuItems.filter((menu) => {
        if (menu.roles) {
            return member?.roles?.some((role) => menu.roles.includes(role));
        }
        return true;
    });

    const toggleMenu = (index) => {
        setOpenMenu(openMenu === index ? null : index);
    };

    // 대메뉴가 path가 없으면 클릭 시 defaultPath로 이동하도록 처리
    const handleMainMenuClick = (menu, index) => {
        if (!menu.path && menu.defaultPath) {
            navigator(menu.defaultPath);
        }
        toggleMenu(index);
    };

    // useEffect: URL 변화에 따라 active(열린) 메뉴를 한 번만 결정
    useEffect(() => {
        const effectivePathname = pathname === "/" ? "/dashboard" : pathname;
        let newOpenMenu = null;
        for (let i = 0; i < filteredMenuItems.length; i++) {
            const menu = filteredMenuItems[i];
            if (menu.path && (effectivePathname === menu.path || effectivePathname.startsWith(`${menu.path}/`))) {
                newOpenMenu = i;
                break;
            }
            if (menu.sub) {
                for (let j = 0; j < menu.sub.length; j++) {
                    const subMenu = menu.sub[j];
                    if (subMenu.path && (effectivePathname === subMenu.path || effectivePathname.startsWith(`${subMenu.path}/`))) {
                        newOpenMenu = i;
                        break;
                    }
                }
                if (newOpenMenu !== null) break;
            }
        }
        setOpenMenu(newOpenMenu);
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, [pathname, filteredMenuItems]);

    return (
        <>
            <nav key={navKey} className={navToggleStatus ? "hidden" : ""}>
                <div className="header">
                    <span
                        className="logo"
                        onClick={() => {
                            navigator("/dashboard");
                        }}
                    >
                        <img src={logoImg} alt="" />
                    </span>
                </div>

                <div className="nav">
                    <ul>
                        {filteredMenuItems.map((menu, index) => (
                            <li
                                key={index}
                                className={
                                    (menu.path && (pathname === menu.path || pathname.startsWith(`${menu.path}/`))) ||
                                    (menu.sub && menu.sub.some((sub) => pathname === sub.path || pathname.startsWith(`${sub.path}/`))) ||
                                    openMenu === index
                                        ? "active"
                                        : ""
                                }
                            >
                                {menu.path ? (
                                    <NavLink className="menu-head" to={menu.path}>
                                        <span className="menu-img">
                                            <menu.icon
                                                className={
                                                    (menu.path && (pathname === menu.path || pathname.startsWith(`${menu.path}/`))) ||
                                                    (menu.sub &&
                                                        menu.sub.some(
                                                            (sub) => pathname === sub.path || pathname.startsWith(`${sub.path}/`)
                                                        ))
                                                        ? "active-icon"
                                                        : "inactive-icon"
                                                }
                                            />
                                        </span>
                                        <span className="menu-txt">{menu.label}</span>
                                    </NavLink>
                                ) : (
                                    <>
                                        <span className="menu-head" onClick={() => handleMainMenuClick(menu, index)}>
                                            <span className="menu-img">
                                                <menu.icon className="inactive-icon" />
                                            </span>
                                            <span className="menu-txt">{menu.label}</span>
                                        </span>
                                        {menu.sub && (
                                            <ul className={`menu-sub ${openMenu === index ? "open" : ""}`}>
                                                {menu.sub
                                                    .filter((sub) => sub.display !== false)
                                                    .map((subMenu, subIndex) => (
                                                        <li
                                                            key={subIndex}
                                                            className={
                                                                pathname === subMenu.path || pathname.startsWith(`${subMenu.path}/`)
                                                                    ? "active"
                                                                    : subMenu.develop === false
                                                                    ? "develop"
                                                                    : ""
                                                            }
                                                        >
                                                            <NavLink to={subMenu.path}>{subMenu.label}</NavLink>
                                                        </li>
                                                    ))}
                                            </ul>
                                        )}
                                    </>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>

                <button
                    type="button"
                    className="btn-nav_toggle"
                    onClick={() => {
                        setNavToggleStatus(!navToggleStatus);
                    }}
                ></button>
            </nav>
        </>
    );
};

export default Nav;
